import { render, staticRenderFns } from "./CadastroCampanha.vue?vue&type=template&id=cb0c3706&"
import script from "./CadastroCampanha.vue?vue&type=script&lang=js&"
export * from "./CadastroCampanha.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCampanha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports